import React, { useEffect, useState } from "react";
import Card from "../components/Card";
import Button from "../components/Button";
import API from "../api/api"; // Axios con token

export default function Notificaciones() {
  const [notifs, setNotifs] = useState([]);
  const [loading, setLoading] = useState(true);


  // Cargar desde backend
  // GET /notificaciones/

  const cargarNotificaciones = async () => {
    try {
      const res = await API.get("/notificaciones/");
      setNotifs(res.data);
    } catch (err) {
      console.error("Error cargando notificaciones", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarNotificaciones();
  }, []);


  // Marcar una sola como leída


  const marcarComoLeido = async (id) => {
    try {
      await API.post(`/notificaciones/${id}/leida/`);

      // actualizar localmente
      setNotifs((prev) =>
        prev.map((n) => (n.id === id ? { ...n, leido: true } : n))
      );
    } catch (err) {
      console.error("Error al marcar como leída", err);
    }
  };


  // Marcar TODAS como leídas


  const marcarTodo = async () => {
    try {
      await API.post("/notificaciones/marcar-todas/");

      setNotifs((prev) => prev.map((n) => ({ ...n, leido: true })));
    } catch (err) {
      console.error("Error marcando todas", err);
    }
  };

  const getColor = (type) => {
    switch (type) {
      case "oferta":
        return "bg-blue-100 text-blue-700";
      case "pago_ok":
        return "bg-emerald-100 text-emerald-700";
      case "pago_fail":
        return "bg-red-100 text-red-700";
      case "mensaje":
        return "bg-yellow-100 text-yellow-700";
      case "cobro":
        return "bg-cyan-100 text-cyan-700";
      default:
        return "bg-slate-100 text-slate-700";
    }
  };

  if (loading)
    return <p className="text-primary text-center mt-10">Cargando notificaciones...</p>;

  return (
    <div className="space-y-6">
      {/* TITULO */}
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-primary">Notificaciones</h1>

        <Button className="bg-primary text-white" onClick={marcarTodo}>
          Marcar todo como leído
        </Button>
      </div>

      {/* LISTA */}
      {notifs.length === 0 ? (
        <p className="text-slate-500">No tienes notificaciones.</p>
      ) : (
        <div className="space-y-4">
          {notifs.map((n) => (
            <Card
              key={n.id}
              className={`border-l-4 ${
                n.leido ? "opacity-60 border-slate-300" : "border-primary"
              }`}
            >
              <div className="flex justify-between">
                <div>
                  <span
                    className={`px-3 py-1 rounded text-xs font-semibold ${getColor(
                      n.tipo
                    )}`}
                  >
                    {n.tipo.toUpperCase()}
                  </span>

                  <h3 className="font-semibold text-lg mt-2">{n.titulo}</h3>

                  <p className="text-slate-600 text-sm mt-1">{n.descripcion}</p>

                  <p className="text-xs text-slate-400 mt-2">
                    {new Date(n.fecha).toLocaleString()}
                  </p>
                </div>

                {!n.leido && (
                  <Button
                    className="h-10 bg-slate-600 text-white"
                    onClick={() => marcarComoLeido(n.id)}
                  >
                    Marcar leído
                  </Button>
                )}
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
